import type { CustomErrorRule } from '@/core/error/transport/types'
import { TmApiBandwidthNotEnoughPermissionError } from '@/core/error/transport/tmApiBandwidthNotEnoughPermissionError'

export const byocBandwidthNotEnoughPermissionErrorRule: CustomErrorRule = {
  subCodes: ['byoc.credentials.bandwidth.not_enough_permission'],
  klass: TmApiBandwidthNotEnoughPermissionError,
}
